import { Link } from "react-router-dom";
import { ArrowRight, MapPin, Phone } from "lucide-react";
import { Seo } from "@/components/site/Seo";
import { areasHubMeta } from "@/seo/routeMeta";
import { Breadcrumb } from "@/components/service/ServiceHero";
import { SectionLink } from "@/components/site/SectionLink";
import { AREAS_HUB, TOWNS } from "@/components/site/areaContent";
import { PHONE_DISPLAY, PHONE_HREF } from "@/components/site/data";

export default function AreasHub() {
  return (
    <div data-testid="areas-hub-page">
      <Seo {...areasHubMeta()} />
      <section className="bg-white">
        <div className="mx-auto max-w-7xl px-5 pb-16 pt-8 sm:px-8 lg:pb-24">
          <Breadcrumb title="Service Areas" />
          <p className="eyebrow mt-12">Chatham-Kent, Ontario</p>
          <h1 data-testid="areas-hub-heading" className="mt-5 font-heading text-4xl font-semibold leading-[1.12] tracking-tight text-brand-navy sm:text-5xl">{AREAS_HUB.h1}</h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-brand-slate md:text-lg">{AREAS_HUB.intro}</p>
          <ul className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {TOWNS.map((t) => (
              <li key={t.slug}>
                <Link to={`/areas/${t.slug}`} data-testid={`areas-hub-card-${t.slug}`} className="soft-card flex h-full flex-col p-6 transition-shadow duration-300 hover:shadow-md">
                  <MapPin className="h-6 w-6 text-brand-blue" strokeWidth={1.6} />
                  <h2 className="mt-4 font-heading text-lg font-semibold text-brand-navy">{t.name}</h2>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-brand-slate">{t.cardDesc}</p>
                  <span className="link-arrow mt-4">View {t.name} <ArrowRight className="h-4 w-4" /></span>
                </Link>
              </li>
            ))}
          </ul>
          <p className="mt-10 font-heading text-base font-semibold text-brand-navy" data-testid="areas-hub-also">Also serving all of Chatham-Kent and surrounding areas.</p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <SectionLink hash="#contact" data-testid="areas-hub-quote-button" className="btn-primary">Request a Quote <ArrowRight className="h-4 w-4" /></SectionLink>
            <a href={PHONE_HREF} data-testid="areas-hub-call-button" className="btn-secondary"><Phone className="h-4 w-4" /> Call {PHONE_DISPLAY}</a>
          </div>
        </div>
      </section>
    </div>
  );
}
